var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** Denotes the high level category for this product. */
export var ProductType;
(function (ProductType) {
    /** An accessory to a headlight. */
    ProductType["Accessory"] = "ACCESSORY";
    /** A dedicated family of headlight. */
    ProductType["Headlight"] = "HEADLIGHT";
})(ProductType || (ProductType = {}));
/** The current status of a given good belonging to an RGA. */
export var RgaGoodStatus;
(function (RgaGoodStatus) {
    /** The good was removed from the request at some point. */
    RgaGoodStatus["Archived"] = "ARCHIVED";
    /** Indicates a good has been delayed from shipping. */
    RgaGoodStatus["Delayed"] = "DELAYED";
    /** The good is considered valid and part of the request. */
    RgaGoodStatus["Valid"] = "VALID";
})(RgaGoodStatus || (RgaGoodStatus = {}));
/** Indicates the shipping carrier used to transport a good associated to an RGA. */
export var RgaShippingCarrier;
(function (RgaShippingCarrier) {
    /** DHL as a shipping carrier. */
    RgaShippingCarrier["Dhl"] = "DHL";
    /** FedEx as a shipping carrier. */
    RgaShippingCarrier["Fedex"] = "FEDEX";
    /** Another shipping carrier not fully supported by the system. */
    RgaShippingCarrier["Other"] = "OTHER";
    /** UPS as a shipping carrier. */
    RgaShippingCarrier["Ups"] = "UPS";
})(RgaShippingCarrier || (RgaShippingCarrier = {}));
/** Indicates the shipping status for a given good that belongs to an RGA. */
export var RgaShippingStatus;
(function (RgaShippingStatus) {
    /** Indicates that a given item could not be shipped for various reasons. */
    RgaShippingStatus["Delayed"] = "DELAYED";
    /** Indicates an RGA good has shipped. */
    RgaShippingStatus["Shipped"] = "SHIPPED";
})(RgaShippingStatus || (RgaShippingStatus = {}));
/** Defines a state a given RGA could be in. */
export var RgaStatus;
(function (RgaStatus) {
    /** RPMED team is assessing the contents of the package. */
    RgaStatus["Assessing"] = "ASSESSING";
    /**
     * The customer has confirmed the goods associated to the request and
     * RPMED is awaiting the delivery of the customer's package.
     */
    RgaStatus["AwaitingArrival"] = "AWAITING_ARRIVAL";
    /**
     * The request was canceled at any point during the process. Notes may
     * may be added for further explanation.
     */
    RgaStatus["Canceled"] = "CANCELED";
    /** The request is complete and no further notes / changes can be made. */
    RgaStatus["Closed"] = "CLOSED";
    /**
     * Indicates the RGA may have partially shipped but still has some pending
     * items that have been delayed.
     */
    RgaStatus["Delayed"] = "DELAYED";
    /**
     * An RGA number has been issued to the distributor but the customer
     * has not completed or shipped the package.
     */
    RgaStatus["Issued"] = "ISSUED";
    /** RPMED team is making any necessary repairs. */
    RgaStatus["Repairing"] = "REPAIRING";
    /** RPMED team has shipped the package back to the customer. */
    RgaStatus["Shipping"] = "SHIPPING";
})(RgaStatus || (RgaStatus = {}));
/** Indicates whether or not an image is currently transferring, available, or even deleted. */
export var UploadStatus;
(function (UploadStatus) {
    UploadStatus["Available"] = "AVAILABLE";
    UploadStatus["Deleted"] = "DELETED";
    UploadStatus["Pending"] = "PENDING";
})(UploadStatus || (UploadStatus = {}));
export var AttachImagesToSymptomDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation AttachImagesToSymptom($symptomId: String!, $attachedImages: [AttachedImageInput]!) {\n  response: attachImagesToSymptom(\n    symptomId: $symptomId\n    attachedImages: $attachedImages\n  ) {\n    productSymptom {\n      id\n      attachedImages {\n        position\n        status\n        id\n        url\n      }\n    }\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation AttachImagesToSymptom($symptomId: String!, $attachedImages: [AttachedImageInput]!) {\n  response: attachImagesToSymptom(\n    symptomId: $symptomId\n    attachedImages: $attachedImages\n  ) {\n    productSymptom {\n      id\n      attachedImages {\n        position\n        status\n        id\n        url\n      }\n    }\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useAttachImagesToSymptomMutation__
 *
 * To run a mutation, you first call `useAttachImagesToSymptomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachImagesToSymptomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachImagesToSymptomMutation, { data, loading, error }] = useAttachImagesToSymptomMutation({
 *   variables: {
 *      symptomId: // value for 'symptomId'
 *      attachedImages: // value for 'attachedImages'
 *   },
 * });
 */
export function useAttachImagesToSymptomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AttachImagesToSymptomDocument, options);
}
export var CreateCustomerDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation CreateCustomer($customerInput: NewCustomerInput!) {\n  response: createCustomer(customerInput: $customerInput) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation CreateCustomer($customerInput: NewCustomerInput!) {\n  response: createCustomer(customerInput: $customerInput) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      customerInput: // value for 'customerInput'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateCustomerDocument, options);
}
export var CreateDistributorDocument = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    mutation CreateDistributor($distributorInput: NewDistributorInput!) {\n  response: createDistributor(distributorInput: $distributorInput) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation CreateDistributor($distributorInput: NewDistributorInput!) {\n  response: createDistributor(distributorInput: $distributorInput) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCreateDistributorMutation__
 *
 * To run a mutation, you first call `useCreateDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDistributorMutation, { data, loading, error }] = useCreateDistributorMutation({
 *   variables: {
 *      distributorInput: // value for 'distributorInput'
 *   },
 * });
 */
export function useCreateDistributorMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateDistributorDocument, options);
}
export var CreateModelNumberDocument = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    mutation CreateModelNumber($modelNumberInput: ModelNumberInput!) {\n  response: createModelNumber(modelNumberInput: $modelNumberInput) {\n    modelNumber {\n      id\n      description\n      productIds\n      products {\n        id\n        name\n      }\n      productType\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      pricing {\n        cost\n        retail\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation CreateModelNumber($modelNumberInput: ModelNumberInput!) {\n  response: createModelNumber(modelNumberInput: $modelNumberInput) {\n    modelNumber {\n      id\n      description\n      productIds\n      products {\n        id\n        name\n      }\n      productType\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      pricing {\n        cost\n        retail\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCreateModelNumberMutation__
 *
 * To run a mutation, you first call `useCreateModelNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelNumberMutation, { data, loading, error }] = useCreateModelNumberMutation({
 *   variables: {
 *      modelNumberInput: // value for 'modelNumberInput'
 *   },
 * });
 */
export function useCreateModelNumberMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateModelNumberDocument, options);
}
export var CreateProductDocument = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    mutation CreateProduct($productInput: ProductInput!) {\n  response: createProduct(productInput: $productInput) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation CreateProduct($productInput: ProductInput!) {\n  response: createProduct(productInput: $productInput) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateProductDocument, options);
}
export var CreateProductRegistrationDocument = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    mutation CreateProductRegistration($productRegistrationInput: NewProductRegistrationInput!) {\n  response: createProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    success\n    productRegistration {\n      id\n      customer {\n        id\n        email\n        name\n      }\n      modelNumber\n      productId\n      customerId\n      serial\n    }\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation CreateProductRegistration($productRegistrationInput: NewProductRegistrationInput!) {\n  response: createProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    success\n    productRegistration {\n      id\n      customer {\n        id\n        email\n        name\n      }\n      modelNumber\n      productId\n      customerId\n      serial\n    }\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useCreateProductRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateProductRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductRegistrationMutation, { data, loading, error }] = useCreateProductRegistrationMutation({
 *   variables: {
 *      productRegistrationInput: // value for 'productRegistrationInput'
 *   },
 * });
 */
export function useCreateProductRegistrationMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateProductRegistrationDocument, options);
}
export var CreateProductSymptomDocument = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    mutation CreateProductSymptom($productSymptomInput: NewProductSymptomInput!) {\n  response: createProductSymptom(productSymptomInput: $productSymptomInput) {\n    productSymptom {\n      id\n      name\n      fee\n      faultCode\n      synopsis\n      solution\n      careTip\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation CreateProductSymptom($productSymptomInput: NewProductSymptomInput!) {\n  response: createProductSymptom(productSymptomInput: $productSymptomInput) {\n    productSymptom {\n      id\n      name\n      fee\n      faultCode\n      synopsis\n      solution\n      careTip\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useCreateProductSymptomMutation__
 *
 * To run a mutation, you first call `useCreateProductSymptomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSymptomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSymptomMutation, { data, loading, error }] = useCreateProductSymptomMutation({
 *   variables: {
 *      productSymptomInput: // value for 'productSymptomInput'
 *   },
 * });
 */
export function useCreateProductSymptomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateProductSymptomDocument, options);
}
export var CreateRgaGoodDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    mutation CreateRGAGood($rgaId: String!, $rgaGoodInput: RGAGoodInput!) {\n  response: createRGAGood(rgaId: $rgaId, rgaGoodInput: $rgaGoodInput) {\n    rgaId\n    rgaGood {\n      id\n      rgaId\n      serviceId\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      faultCode\n      serial\n      newSerial\n      lotted\n      preApproved\n      productId\n      productName\n      productType\n      symptomId\n      symptomDescription\n      symptomSolution\n      symptomSynopsis\n      modelNumber\n      po\n      rma\n      warrantied\n      warrantyTerm\n      warrantyDescription\n      notes\n      serviceFormUrl\n      customerLetterUrl\n      additionalComments\n      datePurchased\n      disposition\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation CreateRGAGood($rgaId: String!, $rgaGoodInput: RGAGoodInput!) {\n  response: createRGAGood(rgaId: $rgaId, rgaGoodInput: $rgaGoodInput) {\n    rgaId\n    rgaGood {\n      id\n      rgaId\n      serviceId\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      faultCode\n      serial\n      newSerial\n      lotted\n      preApproved\n      productId\n      productName\n      productType\n      symptomId\n      symptomDescription\n      symptomSolution\n      symptomSynopsis\n      modelNumber\n      po\n      rma\n      warrantied\n      warrantyTerm\n      warrantyDescription\n      notes\n      serviceFormUrl\n      customerLetterUrl\n      additionalComments\n      datePurchased\n      disposition\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCreateRgaGoodMutation__
 *
 * To run a mutation, you first call `useCreateRgaGoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRgaGoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRgaGoodMutation, { data, loading, error }] = useCreateRgaGoodMutation({
 *   variables: {
 *      rgaId: // value for 'rgaId'
 *      rgaGoodInput: // value for 'rgaGoodInput'
 *   },
 * });
 */
export function useCreateRgaGoodMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateRgaGoodDocument, options);
}
export var CreateRgaDocument = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    mutation CreateRGA($rgaInput: NewRGAInput!) {\n  response: createRGA(rgaInput: $rgaInput) {\n    rga {\n      id\n      shippingSpeed\n      status\n      submittedBy\n      submittedOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation CreateRGA($rgaInput: NewRGAInput!) {\n  response: createRGA(rgaInput: $rgaInput) {\n    rga {\n      id\n      shippingSpeed\n      status\n      submittedBy\n      submittedOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCreateRgaMutation__
 *
 * To run a mutation, you first call `useCreateRgaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRgaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRgaMutation, { data, loading, error }] = useCreateRgaMutation({
 *   variables: {
 *      rgaInput: // value for 'rgaInput'
 *   },
 * });
 */
export function useCreateRgaMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateRgaDocument, options);
}
export var CreateUploadsDocument = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    mutation CreateUploads($uploadInput: UploadInput!) {\n  response: createUploads(uploadInput: $uploadInput) {\n    uploads {\n      id\n      url\n    }\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation CreateUploads($uploadInput: UploadInput!) {\n  response: createUploads(uploadInput: $uploadInput) {\n    uploads {\n      id\n      url\n    }\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useCreateUploadsMutation__
 *
 * To run a mutation, you first call `useCreateUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadsMutation, { data, loading, error }] = useCreateUploadsMutation({
 *   variables: {
 *      uploadInput: // value for 'uploadInput'
 *   },
 * });
 */
export function useCreateUploadsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateUploadsDocument, options);
}
export var CreateUserDocument = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    mutation CreateUser($userInput: NewUserInput!) {\n  response: createUser(userInput: $userInput) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation CreateUser($userInput: NewUserInput!) {\n  response: createUser(userInput: $userInput) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateUserDocument, options);
}
export var CustomerDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    query Customer($customerId: String!) {\n  response: customer(id: $customerId) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query Customer($customerId: String!) {\n  response: customer(id: $customerId) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CustomerDocument, options);
}
export function useCustomerLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CustomerDocument, options);
}
export var CustomersDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    query Customers($search: String) {\n  response: customers(search: $search) {\n    customers {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query Customers($search: String) {\n  response: customers(search: $search) {\n    customers {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CustomersDocument, options);
}
export function useCustomersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CustomersDocument, options);
}
export var DestroyDistributorDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    mutation DestroyDistributor($id: String!) {\n  response: destroyDistributor(id: $id) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation DestroyDistributor($id: String!) {\n  response: destroyDistributor(id: $id) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyDistributorMutation__
 *
 * To run a mutation, you first call `useDestroyDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDistributorMutation, { data, loading, error }] = useDestroyDistributorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyDistributorMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyDistributorDocument, options);
}
export var DestroyCustomerDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    mutation DestroyCustomer($id: String!) {\n  response: destroyCustomer(id: $id) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation DestroyCustomer($id: String!) {\n  response: destroyCustomer(id: $id) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyCustomerMutation__
 *
 * To run a mutation, you first call `useDestroyCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCustomerMutation, { data, loading, error }] = useDestroyCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyCustomerMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyCustomerDocument, options);
}
export var DestroyDocumentDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    mutation DestroyDocument($id: String!) {\n  response: destroyDocument(id: $id) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation DestroyDocument($id: String!) {\n  response: destroyDocument(id: $id) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useDestroyDocumentMutation__
 *
 * To run a mutation, you first call `useDestroyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDocumentMutation, { data, loading, error }] = useDestroyDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyDocumentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyDocumentDocument, options);
}
export var DestroyModelNumberDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    mutation destroyModelNumber($id: ID!) {\n  response: destroyModelNumber(id: $id) {\n    modelNumber {\n      id\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation destroyModelNumber($id: ID!) {\n  response: destroyModelNumber(id: $id) {\n    modelNumber {\n      id\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyModelNumberMutation__
 *
 * To run a mutation, you first call `useDestroyModelNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyModelNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyModelNumberMutation, { data, loading, error }] = useDestroyModelNumberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyModelNumberMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyModelNumberDocument, options);
}
export var DestroyPageDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    mutation DestroyPage($id: String!) {\n  response: destroyPage(id: $id) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation DestroyPage($id: String!) {\n  response: destroyPage(id: $id) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useDestroyPageMutation__
 *
 * To run a mutation, you first call `useDestroyPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyPageMutation, { data, loading, error }] = useDestroyPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyPageMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyPageDocument, options);
}
export var DestroyProductDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    mutation DestroyProduct($id: ID!) {\n  response: destroyProduct(id: $id) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation DestroyProduct($id: ID!) {\n  response: destroyProduct(id: $id) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyProductMutation__
 *
 * To run a mutation, you first call `useDestroyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProductMutation, { data, loading, error }] = useDestroyProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyProductMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyProductDocument, options);
}
export var DestroyProductRegistrationDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    mutation DestroyProductRegistration($id: String!) {\n  response: destroyProductRegistration(id: $id) {\n    productRegistration {\n      id\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation DestroyProductRegistration($id: String!) {\n  response: destroyProductRegistration(id: $id) {\n    productRegistration {\n      id\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyProductRegistrationMutation__
 *
 * To run a mutation, you first call `useDestroyProductRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProductRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProductRegistrationMutation, { data, loading, error }] = useDestroyProductRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyProductRegistrationMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyProductRegistrationDocument, options);
}
export var DestroyProductSymptomDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    mutation destroyProductSymptom($id: String!) {\n  response: destroyProductSymptom(id: $id) {\n    productSymptom {\n      id\n      name\n      faultCode\n      fee\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation destroyProductSymptom($id: String!) {\n  response: destroyProductSymptom(id: $id) {\n    productSymptom {\n      id\n      name\n      faultCode\n      fee\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyProductSymptomMutation__
 *
 * To run a mutation, you first call `useDestroyProductSymptomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProductSymptomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProductSymptomMutation, { data, loading, error }] = useDestroyProductSymptomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyProductSymptomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyProductSymptomDocument, options);
}
export var DestroyRgaGoodDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    mutation DestroyRGAGood($id: ID!, $rgaId: String!) {\n  response: destroyRGAGood(id: $id, rgaId: $rgaId) {\n    rgaId\n    rgaGood {\n      modelNumber\n      serial\n      id\n      warrantied\n      faultCode\n      status\n      symptomId\n      symptomDescription\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      notes\n      rma\n      po\n      additionalComments\n      datePurchased\n      disposition\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation DestroyRGAGood($id: ID!, $rgaId: String!) {\n  response: destroyRGAGood(id: $id, rgaId: $rgaId) {\n    rgaId\n    rgaGood {\n      modelNumber\n      serial\n      id\n      warrantied\n      faultCode\n      status\n      symptomId\n      symptomDescription\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      notes\n      rma\n      po\n      additionalComments\n      datePurchased\n      disposition\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useDestroyRgaGoodMutation__
 *
 * To run a mutation, you first call `useDestroyRgaGoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyRgaGoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyRgaGoodMutation, { data, loading, error }] = useDestroyRgaGoodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rgaId: // value for 'rgaId'
 *   },
 * });
 */
export function useDestroyRgaGoodMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyRgaGoodDocument, options);
}
export var DestroyUserDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    mutation destroyUser($id: String!) {\n  response: destroyUser(id: $id) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation destroyUser($id: String!) {\n  response: destroyUser(id: $id) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useDestroyUserMutation__
 *
 * To run a mutation, you first call `useDestroyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyUserMutation, { data, loading, error }] = useDestroyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroyUserDocument, options);
}
export var DistributorDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    query Distributor($distributorId: String!) {\n  response: distributor(id: $distributorId) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query Distributor($distributorId: String!) {\n  response: distributor(id: $distributorId) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useDistributorQuery__
 *
 * To run a query within a React component, call `useDistributorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorQuery({
 *   variables: {
 *      distributorId: // value for 'distributorId'
 *   },
 * });
 */
export function useDistributorQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DistributorDocument, options);
}
export function useDistributorLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DistributorDocument, options);
}
export var DistributorsDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    query Distributors {\n  response: distributors {\n    distributors {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query Distributors {\n  response: distributors {\n    distributors {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useDistributorsQuery__
 *
 * To run a query within a React component, call `useDistributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDistributorsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DistributorsDocument, options);
}
export function useDistributorsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DistributorsDocument, options);
}
export var DocumentDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    query Document($id: ID!) {\n  response: document(id: $id) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query Document($id: ID!) {\n  response: document(id: $id) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DocumentDocument, options);
}
export function useDocumentLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DocumentDocument, options);
}
export var DocumentsDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    query Documents {\n  response: documents {\n    documents {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query Documents {\n  response: documents {\n    documents {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DocumentsDocument, options);
}
export function useDocumentsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DocumentsDocument, options);
}
export var LinkSymptomToModelNumberDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    mutation LinkSymptomToModelNumber($modelNumber: String!, $symptomId: String!, $linked: Boolean!) {\n  response: linkSymptomToModel(\n    modelNumber: $modelNumber\n    symptomId: $symptomId\n    linked: $linked\n  ) {\n    success\n    productSymptom {\n      id\n      name\n      associatedModelNumbers\n    }\n    modelNumber {\n      id\n      symptoms {\n        id\n        faultCode\n        name\n      }\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation LinkSymptomToModelNumber($modelNumber: String!, $symptomId: String!, $linked: Boolean!) {\n  response: linkSymptomToModel(\n    modelNumber: $modelNumber\n    symptomId: $symptomId\n    linked: $linked\n  ) {\n    success\n    productSymptom {\n      id\n      name\n      associatedModelNumbers\n    }\n    modelNumber {\n      id\n      symptoms {\n        id\n        faultCode\n        name\n      }\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useLinkSymptomToModelNumberMutation__
 *
 * To run a mutation, you first call `useLinkSymptomToModelNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSymptomToModelNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSymptomToModelNumberMutation, { data, loading, error }] = useLinkSymptomToModelNumberMutation({
 *   variables: {
 *      modelNumber: // value for 'modelNumber'
 *      symptomId: // value for 'symptomId'
 *      linked: // value for 'linked'
 *   },
 * });
 */
export function useLinkSymptomToModelNumberMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(LinkSymptomToModelNumberDocument, options);
}
export var MakeDocumentDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    mutation MakeDocument($documentInput: DocumentInput!) {\n  response: makeDocument(documentInput: $documentInput) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation MakeDocument($documentInput: DocumentInput!) {\n  response: makeDocument(documentInput: $documentInput) {\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useMakeDocumentMutation__
 *
 * To run a mutation, you first call `useMakeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeDocumentMutation, { data, loading, error }] = useMakeDocumentMutation({
 *   variables: {
 *      documentInput: // value for 'documentInput'
 *   },
 * });
 */
export function useMakeDocumentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MakeDocumentDocument, options);
}
export var MakePageDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    mutation MakePage($pageInput: PageInput!) {\n  response: makePage(pageInput: $pageInput) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          name\n          position\n          icon\n          url\n          target\n          type\n        }\n      }\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation MakePage($pageInput: PageInput!) {\n  response: makePage(pageInput: $pageInput) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          name\n          position\n          icon\n          url\n          target\n          type\n        }\n      }\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useMakePageMutation__
 *
 * To run a mutation, you first call `useMakePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePageMutation, { data, loading, error }] = useMakePageMutation({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useMakePageMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MakePageDocument, options);
}
export var ModelNumberDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    query ModelNumber($modelNumberId: String!) {\n  response: modelNumber(id: $modelNumberId) {\n    modelNumber {\n      id\n      description\n      productIds\n      productType\n      products {\n        id\n        name\n      }\n      symptoms {\n        id\n        name\n        faultCode\n      }\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      pricing {\n        cost\n        retail\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query ModelNumber($modelNumberId: String!) {\n  response: modelNumber(id: $modelNumberId) {\n    modelNumber {\n      id\n      description\n      productIds\n      productType\n      products {\n        id\n        name\n      }\n      symptoms {\n        id\n        name\n        faultCode\n      }\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      pricing {\n        cost\n        retail\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useModelNumberQuery__
 *
 * To run a query within a React component, call `useModelNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelNumberQuery({
 *   variables: {
 *      modelNumberId: // value for 'modelNumberId'
 *   },
 * });
 */
export function useModelNumberQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ModelNumberDocument, options);
}
export function useModelNumberLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ModelNumberDocument, options);
}
export var ModelNumbersLottedDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    query ModelNumbersLotted {\n  response: modelNumbers {\n    modelNumbers {\n      id\n      lotted\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query ModelNumbersLotted {\n  response: modelNumbers {\n    modelNumbers {\n      id\n      lotted\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useModelNumbersLottedQuery__
 *
 * To run a query within a React component, call `useModelNumbersLottedQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelNumbersLottedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelNumbersLottedQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelNumbersLottedQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ModelNumbersLottedDocument, options);
}
export function useModelNumbersLottedLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ModelNumbersLottedDocument, options);
}
export var ModelNumbersDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    query ModelNumbers($search: String, $productId: String, $productType: ProductType) {\n  response: modelNumbers(\n    search: $search\n    productId: $productId\n    productType: $productType\n  ) {\n    modelNumbers {\n      id\n      lotted\n      warrantyTerm\n      warrantyDescription\n      productType\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      products {\n        id\n        name\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      description\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query ModelNumbers($search: String, $productId: String, $productType: ProductType) {\n  response: modelNumbers(\n    search: $search\n    productId: $productId\n    productType: $productType\n  ) {\n    modelNumbers {\n      id\n      lotted\n      warrantyTerm\n      warrantyDescription\n      productType\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      products {\n        id\n        name\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      description\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useModelNumbersQuery__
 *
 * To run a query within a React component, call `useModelNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelNumbersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      productId: // value for 'productId'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useModelNumbersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ModelNumbersDocument, options);
}
export function useModelNumbersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ModelNumbersDocument, options);
}
export var ModelNumbersSimpleDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    query ModelNumbersSimple {\n  response: modelNumbers {\n    modelNumbers {\n      id\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query ModelNumbersSimple {\n  response: modelNumbers {\n    modelNumbers {\n      id\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useModelNumbersSimpleQuery__
 *
 * To run a query within a React component, call `useModelNumbersSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelNumbersSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelNumbersSimpleQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelNumbersSimpleQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ModelNumbersSimpleDocument, options);
}
export function useModelNumbersSimpleLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ModelNumbersSimpleDocument, options);
}
export var ModelNumbersViewableDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    query ModelNumbersViewable {\n  response: modelNumbers {\n    modelNumbers {\n      id\n      publiclyViewable\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query ModelNumbersViewable {\n  response: modelNumbers {\n    modelNumbers {\n      id\n      publiclyViewable\n    }\n    pageSize\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useModelNumbersViewableQuery__
 *
 * To run a query within a React component, call `useModelNumbersViewableQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelNumbersViewableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelNumbersViewableQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelNumbersViewableQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ModelNumbersViewableDocument, options);
}
export function useModelNumbersViewableLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ModelNumbersViewableDocument, options);
}
export var PageDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    query Page($id: ID!) {\n  response: page(id: $id) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          name\n          description\n          position\n          icon\n          url\n          target\n          type\n        }\n      }\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query Page($id: ID!) {\n  response: page(id: $id) {\n    page {\n      id\n      title\n      keywords\n      description\n      slug\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          name\n          description\n          position\n          icon\n          url\n          target\n          type\n        }\n      }\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PageDocument, options);
}
export function usePageLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PageDocument, options);
}
export var PagesDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    query Pages {\n  response: pages {\n    pages {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    query Pages {\n  response: pages {\n    pages {\n      id\n      title\n      keywords\n      description\n      slug\n    }\n    success\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PagesDocument, options);
}
export function usePagesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PagesDocument, options);
}
export var ProductDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    query Product($productId: String!) {\n  response: product(id: $productId) {\n    product {\n      id\n      name\n      description\n      modelNumbers {\n        id\n        description\n        lotted\n        warrantyTerm\n      }\n    }\n    errors {\n      path\n      message\n    }\n    success\n  }\n}\n    "], ["\n    query Product($productId: String!) {\n  response: product(id: $productId) {\n    product {\n      id\n      name\n      description\n      modelNumbers {\n        id\n        description\n        lotted\n        warrantyTerm\n      }\n    }\n    errors {\n      path\n      message\n    }\n    success\n  }\n}\n    "])));
/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductDocument, options);
}
export function useProductLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductDocument, options);
}
export var ProductRegistrationDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    query ProductRegistration($productRegistrationId: String!) {\n  response: productRegistration(id: $productRegistrationId) {\n    productRegistration {\n      id\n      productId\n      customerId\n      customer {\n        id\n        name\n        email\n      }\n      modelNumber\n      serial\n      lotted\n      street\n      street2\n      phone\n      city\n      state\n      zip\n      country\n      registeredOn\n      purchaseDate\n      purchasedFrom\n      registeredOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query ProductRegistration($productRegistrationId: String!) {\n  response: productRegistration(id: $productRegistrationId) {\n    productRegistration {\n      id\n      productId\n      customerId\n      customer {\n        id\n        name\n        email\n      }\n      modelNumber\n      serial\n      lotted\n      street\n      street2\n      phone\n      city\n      state\n      zip\n      country\n      registeredOn\n      purchaseDate\n      purchasedFrom\n      registeredOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useProductRegistrationQuery__
 *
 * To run a query within a React component, call `useProductRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRegistrationQuery({
 *   variables: {
 *      productRegistrationId: // value for 'productRegistrationId'
 *   },
 * });
 */
export function useProductRegistrationQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductRegistrationDocument, options);
}
export function useProductRegistrationLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductRegistrationDocument, options);
}
export var ProductRegistrationsDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    query ProductRegistrations {\n  response: productRegistrations {\n    productRegistrations {\n      id\n      productId\n      customerId\n      customer {\n        id\n        name\n        email\n      }\n      registeredOn\n      purchaseDate\n      purchasedFrom\n      serial\n      modelNumber\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query ProductRegistrations {\n  response: productRegistrations {\n    productRegistrations {\n      id\n      productId\n      customerId\n      customer {\n        id\n        name\n        email\n      }\n      registeredOn\n      purchaseDate\n      purchasedFrom\n      serial\n      modelNumber\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useProductRegistrationsQuery__
 *
 * To run a query within a React component, call `useProductRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRegistrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductRegistrationsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductRegistrationsDocument, options);
}
export function useProductRegistrationsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductRegistrationsDocument, options);
}
export var ProductSymptomDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    query ProductSymptom($productSymptomId: String!) {\n  response: productSymptom(id: $productSymptomId) {\n    productSymptom {\n      id\n      name\n      faultCode\n      fee\n      preApproved\n      synopsis\n      solution\n      careTip\n      associatedModelNumbers\n      attachedImages {\n        id\n        position\n        status\n        url\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query ProductSymptom($productSymptomId: String!) {\n  response: productSymptom(id: $productSymptomId) {\n    productSymptom {\n      id\n      name\n      faultCode\n      fee\n      preApproved\n      synopsis\n      solution\n      careTip\n      associatedModelNumbers\n      attachedImages {\n        id\n        position\n        status\n        url\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useProductSymptomQuery__
 *
 * To run a query within a React component, call `useProductSymptomQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSymptomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSymptomQuery({
 *   variables: {
 *      productSymptomId: // value for 'productSymptomId'
 *   },
 * });
 */
export function useProductSymptomQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductSymptomDocument, options);
}
export function useProductSymptomLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductSymptomDocument, options);
}
export var ProductSymptomsDocument = gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    query ProductSymptoms($search: String, $modelNumber: String) {\n  response: productSymptoms(search: $search, modelNumber: $modelNumber) {\n    productSymptoms {\n      id\n      name\n      faultCode\n      fee\n      preApproved\n      careTip\n      solution\n      synopsis\n      attachedImages {\n        id\n        position\n        status\n        url\n      }\n      associatedModelNumbers\n    }\n    pageSize\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query ProductSymptoms($search: String, $modelNumber: String) {\n  response: productSymptoms(search: $search, modelNumber: $modelNumber) {\n    productSymptoms {\n      id\n      name\n      faultCode\n      fee\n      preApproved\n      careTip\n      solution\n      synopsis\n      attachedImages {\n        id\n        position\n        status\n        url\n      }\n      associatedModelNumbers\n    }\n    pageSize\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useProductSymptomsQuery__
 *
 * To run a query within a React component, call `useProductSymptomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSymptomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSymptomsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      modelNumber: // value for 'modelNumber'
 *   },
 * });
 */
export function useProductSymptomsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductSymptomsDocument, options);
}
export function useProductSymptomsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductSymptomsDocument, options);
}
export var ProductsDocument = gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    query Products($search: String) {\n  response: products(search: $search) {\n    products {\n      id\n      name\n      description\n    }\n    pageSize\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    query Products($search: String) {\n  response: products(search: $search) {\n    products {\n      id\n      name\n      description\n    }\n    pageSize\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ProductsDocument, options);
}
export function useProductsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ProductsDocument, options);
}
export var ResetPasswordDocument = gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n    mutation ResetPassword($password: String!) {\n  response: resetPassword(password: $password) {\n    user {\n      email\n    }\n    errors {\n      path\n      message\n    }\n    success\n  }\n}\n    "], ["\n    mutation ResetPassword($password: String!) {\n  response: resetPassword(password: $password) {\n    user {\n      email\n    }\n    errors {\n      path\n      message\n    }\n    success\n  }\n}\n    "])));
/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ResetPasswordDocument, options);
}
export var RgaCountsDocument = gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    query RgaCounts {\n  rgaCount {\n    issued\n    delayed\n    awaitingArrival\n    received\n    assessing\n    repairing\n    shipping\n    closed\n    canceled\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    query RgaCounts {\n  rgaCount {\n    issued\n    delayed\n    awaitingArrival\n    received\n    assessing\n    repairing\n    shipping\n    closed\n    canceled\n    success\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useRgaCountsQuery__
 *
 * To run a query within a React component, call `useRgaCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRgaCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRgaCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRgaCountsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(RgaCountsDocument, options);
}
export function useRgaCountsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(RgaCountsDocument, options);
}
export var RgaDocument = gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n    query RGA($rgaId: String!) {\n  response: rga(id: $rgaId) {\n    rga {\n      id\n      shippingSpeed\n      submittedOn\n      submittedBy\n      status\n      statusLog {\n        status\n        updatedOn\n        updatedBy {\n          id\n          name\n          email\n        }\n        notes\n      }\n      goods {\n        id\n        serviceId\n        customerEmail\n        customerId\n        customerName\n        customerLetterUrl\n        customerSpecialty\n        faultCode\n        serial\n        newSerial\n        lotted\n        preApproved\n        productId\n        productName\n        productType\n        symptomId\n        symptomDescription\n        symptomSolution\n        symptomSynopsis\n        modelNumber\n        resolutionFee {\n          distributor\n          endUser\n        }\n        po\n        rma\n        rgaId\n        warrantied\n        warrantyTerm\n        warrantyDescription\n        notes\n        serviceFormUrl\n        shippingSpeed\n        ssd\n        additionalComments\n        datePurchased\n        disposition\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query RGA($rgaId: String!) {\n  response: rga(id: $rgaId) {\n    rga {\n      id\n      shippingSpeed\n      submittedOn\n      submittedBy\n      status\n      statusLog {\n        status\n        updatedOn\n        updatedBy {\n          id\n          name\n          email\n        }\n        notes\n      }\n      goods {\n        id\n        serviceId\n        customerEmail\n        customerId\n        customerName\n        customerLetterUrl\n        customerSpecialty\n        faultCode\n        serial\n        newSerial\n        lotted\n        preApproved\n        productId\n        productName\n        productType\n        symptomId\n        symptomDescription\n        symptomSolution\n        symptomSynopsis\n        modelNumber\n        resolutionFee {\n          distributor\n          endUser\n        }\n        po\n        rma\n        rgaId\n        warrantied\n        warrantyTerm\n        warrantyDescription\n        notes\n        serviceFormUrl\n        shippingSpeed\n        ssd\n        additionalComments\n        datePurchased\n        disposition\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useRgaQuery__
 *
 * To run a query within a React component, call `useRgaQuery` and pass it any options that fit your needs.
 * When your component renders, `useRgaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRgaQuery({
 *   variables: {
 *      rgaId: // value for 'rgaId'
 *   },
 * });
 */
export function useRgaQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(RgaDocument, options);
}
export function useRgaLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(RgaDocument, options);
}
export var RgasDocument = gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    query Rgas($status: RGAStatus) {\n  response: rgas(status: $status) {\n    rgas {\n      id\n      submittedOn\n      submittedBy\n      status\n      goods {\n        id\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    query Rgas($status: RGAStatus) {\n  response: rgas(status: $status) {\n    rgas {\n      id\n      submittedOn\n      submittedBy\n      status\n      goods {\n        id\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useRgasQuery__
 *
 * To run a query within a React component, call `useRgasQuery` and pass it any options that fit your needs.
 * When your component renders, `useRgasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRgasQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useRgasQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(RgasDocument, options);
}
export function useRgasLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(RgasDocument, options);
}
export var UpdateCustomerDocument = gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n    mutation UpdateCustomer($customerInput: ExistingCustomerInput!) {\n  response: updateCustomer(customerInput: $customerInput) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateCustomer($customerInput: ExistingCustomerInput!) {\n  response: updateCustomer(customerInput: $customerInput) {\n    customer {\n      id\n      name\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      customerInput: // value for 'customerInput'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateCustomerDocument, options);
}
export var UpdateDistributorDocument = gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n    mutation UpdateDistributor($distributorInput: ExistingDistributorInput!) {\n  response: updateDistributor(distributorInput: $distributorInput) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateDistributor($distributorInput: ExistingDistributorInput!) {\n  response: updateDistributor(distributorInput: $distributorInput) {\n    distributor {\n      id\n      name\n      domain\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateDistributorMutation__
 *
 * To run a mutation, you first call `useUpdateDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributorMutation, { data, loading, error }] = useUpdateDistributorMutation({
 *   variables: {
 *      distributorInput: // value for 'distributorInput'
 *   },
 * });
 */
export function useUpdateDistributorMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateDistributorDocument, options);
}
export var UpdateModelNumberLottedDocument = gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n    mutation UpdateModelNumberLotted($id: ID!, $lotted: Boolean!) {\n  response: updateModelNumberLotted(id: $id, lotted: $lotted) {\n    modelNumber {\n      id\n      lotted\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateModelNumberLotted($id: ID!, $lotted: Boolean!) {\n  response: updateModelNumberLotted(id: $id, lotted: $lotted) {\n    modelNumber {\n      id\n      lotted\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateModelNumberLottedMutation__
 *
 * To run a mutation, you first call `useUpdateModelNumberLottedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelNumberLottedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelNumberLottedMutation, { data, loading, error }] = useUpdateModelNumberLottedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lotted: // value for 'lotted'
 *   },
 * });
 */
export function useUpdateModelNumberLottedMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateModelNumberLottedDocument, options);
}
export var UpdateModelNumberDocument = gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n    mutation UpdateModelNumber($modelNumberInput: ModelNumberInput!) {\n  response: updateModelNumber(modelNumberInput: $modelNumberInput) {\n    modelNumber {\n      id\n      description\n      productIds\n      products {\n        id\n        name\n      }\n      productType\n      pricing {\n        cost\n        retail\n      }\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateModelNumber($modelNumberInput: ModelNumberInput!) {\n  response: updateModelNumber(modelNumberInput: $modelNumberInput) {\n    modelNumber {\n      id\n      description\n      productIds\n      products {\n        id\n        name\n      }\n      productType\n      pricing {\n        cost\n        retail\n      }\n      lotted\n      warrantyTerm\n      warrantyDescription\n      feeWithWarranty {\n        distributor\n        endUser\n      }\n      feeWithoutWarranty {\n        distributor\n        endUser\n      }\n      resolutionWithWarranty\n      resolutionWithoutWarranty\n      publicNotes\n      privateNotes\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateModelNumberMutation__
 *
 * To run a mutation, you first call `useUpdateModelNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelNumberMutation, { data, loading, error }] = useUpdateModelNumberMutation({
 *   variables: {
 *      modelNumberInput: // value for 'modelNumberInput'
 *   },
 * });
 */
export function useUpdateModelNumberMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateModelNumberDocument, options);
}
export var UpdateModelNumberViewableDocument = gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n    mutation UpdateModelNumberViewable($id: ID!, $publiclyViewable: Boolean!) {\n  response: updateModelNumberViewable(\n    id: $id\n    publiclyViewable: $publiclyViewable\n  ) {\n    modelNumber {\n      id\n      publiclyViewable\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateModelNumberViewable($id: ID!, $publiclyViewable: Boolean!) {\n  response: updateModelNumberViewable(\n    id: $id\n    publiclyViewable: $publiclyViewable\n  ) {\n    modelNumber {\n      id\n      publiclyViewable\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateModelNumberViewableMutation__
 *
 * To run a mutation, you first call `useUpdateModelNumberViewableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelNumberViewableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelNumberViewableMutation, { data, loading, error }] = useUpdateModelNumberViewableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      publiclyViewable: // value for 'publiclyViewable'
 *   },
 * });
 */
export function useUpdateModelNumberViewableMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateModelNumberViewableDocument, options);
}
export var UpdateProductDocument = gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n    mutation UpdateProduct($productInput: ProductInput!) {\n  response: updateProduct(productInput: $productInput) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateProduct($productInput: ProductInput!) {\n  response: updateProduct(productInput: $productInput) {\n    product {\n      id\n      name\n      description\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateProductDocument, options);
}
export var UpdateProductRegistrationDocument = gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n    mutation UpdateProductRegistration($productRegistrationInput: ExistingProductRegistrationInput!) {\n  response: updateProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    success\n    productRegistration {\n      id\n      customer {\n        id\n        email\n        name\n      }\n      modelNumber\n      productId\n      customerId\n      serial\n    }\n    errors {\n      path\n      message\n    }\n  }\n}\n    "], ["\n    mutation UpdateProductRegistration($productRegistrationInput: ExistingProductRegistrationInput!) {\n  response: updateProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    success\n    productRegistration {\n      id\n      customer {\n        id\n        email\n        name\n      }\n      modelNumber\n      productId\n      customerId\n      serial\n    }\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));
/**
 * __useUpdateProductRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateProductRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductRegistrationMutation, { data, loading, error }] = useUpdateProductRegistrationMutation({
 *   variables: {
 *      productRegistrationInput: // value for 'productRegistrationInput'
 *   },
 * });
 */
export function useUpdateProductRegistrationMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateProductRegistrationDocument, options);
}
export var UpdateProductSymptomDocument = gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    mutation UpdateProductSymptom($productSymptomInput: ExistingProductSymptomInput!) {\n  response: updateProductSymptom(productSymptomInput: $productSymptomInput) {\n    productSymptom {\n      id\n      name\n      fee\n      faultCode\n      synopsis\n      solution\n      careTip\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateProductSymptom($productSymptomInput: ExistingProductSymptomInput!) {\n  response: updateProductSymptom(productSymptomInput: $productSymptomInput) {\n    productSymptom {\n      id\n      name\n      fee\n      faultCode\n      synopsis\n      solution\n      careTip\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateProductSymptomMutation__
 *
 * To run a mutation, you first call `useUpdateProductSymptomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductSymptomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductSymptomMutation, { data, loading, error }] = useUpdateProductSymptomMutation({
 *   variables: {
 *      productSymptomInput: // value for 'productSymptomInput'
 *   },
 * });
 */
export function useUpdateProductSymptomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateProductSymptomDocument, options);
}
export var UpdateRgaGoodDocument = gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    mutation UpdateRGAGood($id: ID!, $rgaId: String!, $rgaGoodInput: RGAGoodInput!) {\n  response: updateRGAGood(id: $id, rgaId: $rgaId, rgaGoodInput: $rgaGoodInput) {\n    success\n    errors {\n      message\n      path\n    }\n    rgaId\n    rgaGood {\n      id\n      serviceId\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      faultCode\n      serial\n      newSerial\n      lotted\n      preApproved\n      productId\n      productName\n      productType\n      symptomId\n      symptomDescription\n      symptomSolution\n      symptomSynopsis\n      modelNumber\n      resolutionFee {\n        distributor\n        endUser\n      }\n      po\n      rma\n      warrantied\n      warrantyTerm\n      warrantyDescription\n      notes\n      serviceFormUrl\n      customerLetterUrl\n      ssd\n      additionalComments\n      datePurchased\n      disposition\n    }\n  }\n}\n    "], ["\n    mutation UpdateRGAGood($id: ID!, $rgaId: String!, $rgaGoodInput: RGAGoodInput!) {\n  response: updateRGAGood(id: $id, rgaId: $rgaId, rgaGoodInput: $rgaGoodInput) {\n    success\n    errors {\n      message\n      path\n    }\n    rgaId\n    rgaGood {\n      id\n      serviceId\n      customerId\n      customerEmail\n      customerName\n      customerPhone\n      customerStreet\n      customerStreet2\n      customerZip\n      customerCity\n      customerState\n      customerCountry\n      customerSpecialty\n      faultCode\n      serial\n      newSerial\n      lotted\n      preApproved\n      productId\n      productName\n      productType\n      symptomId\n      symptomDescription\n      symptomSolution\n      symptomSynopsis\n      modelNumber\n      resolutionFee {\n        distributor\n        endUser\n      }\n      po\n      rma\n      warrantied\n      warrantyTerm\n      warrantyDescription\n      notes\n      serviceFormUrl\n      customerLetterUrl\n      ssd\n      additionalComments\n      datePurchased\n      disposition\n    }\n  }\n}\n    "])));
/**
 * __useUpdateRgaGoodMutation__
 *
 * To run a mutation, you first call `useUpdateRgaGoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRgaGoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRgaGoodMutation, { data, loading, error }] = useUpdateRgaGoodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rgaId: // value for 'rgaId'
 *      rgaGoodInput: // value for 'rgaGoodInput'
 *   },
 * });
 */
export function useUpdateRgaGoodMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateRgaGoodDocument, options);
}
export var UpdateRgaDocument = gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n    mutation UpdateRGA($rgaInput: ExistingRGAInput!) {\n  response: updateRGA(rgaInput: $rgaInput) {\n    rga {\n      id\n      shippingSpeed\n      status\n      submittedBy\n      submittedOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation UpdateRGA($rgaInput: ExistingRGAInput!) {\n  response: updateRGA(rgaInput: $rgaInput) {\n    rga {\n      id\n      shippingSpeed\n      status\n      submittedBy\n      submittedOn\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useUpdateRgaMutation__
 *
 * To run a mutation, you first call `useUpdateRgaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRgaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRgaMutation, { data, loading, error }] = useUpdateRgaMutation({
 *   variables: {
 *      rgaInput: // value for 'rgaInput'
 *   },
 * });
 */
export function useUpdateRgaMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateRgaDocument, options);
}
export var UpdateRgaShippingStatusDocument = gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    mutation UpdateRGAShippingStatus($id: ID!, $shippingUpdates: [RGAGoodShippingInput], $notes: String) {\n  response: updateRGAShippingStatus(\n    id: $id\n    shippingUpdates: $shippingUpdates\n    notes: $notes\n  ) {\n    rga {\n      id\n      status\n      submittedBy\n      submittedOn\n      shippingSpeed\n      statusLog {\n        status\n        notes\n        updatedOn\n        updatedBy {\n          name\n          id\n          email\n        }\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation UpdateRGAShippingStatus($id: ID!, $shippingUpdates: [RGAGoodShippingInput], $notes: String) {\n  response: updateRGAShippingStatus(\n    id: $id\n    shippingUpdates: $shippingUpdates\n    notes: $notes\n  ) {\n    rga {\n      id\n      status\n      submittedBy\n      submittedOn\n      shippingSpeed\n      statusLog {\n        status\n        notes\n        updatedOn\n        updatedBy {\n          name\n          id\n          email\n        }\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useUpdateRgaShippingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRgaShippingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRgaShippingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRgaShippingStatusMutation, { data, loading, error }] = useUpdateRgaShippingStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shippingUpdates: // value for 'shippingUpdates'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateRgaShippingStatusMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateRgaShippingStatusDocument, options);
}
export var UpdateRgaStatusDocument = gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n    mutation UpdateRgaStatus($id: ID!, $status: RGAStatus!, $notes: String) {\n  response: updateRGAStatus(id: $id, status: $status, notes: $notes) {\n    rga {\n      id\n      status\n      submittedBy\n      submittedOn\n      shippingSpeed\n      statusLog {\n        status\n        notes\n        updatedOn\n        updatedBy {\n          name\n          id\n          email\n        }\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation UpdateRgaStatus($id: ID!, $status: RGAStatus!, $notes: String) {\n  response: updateRGAStatus(id: $id, status: $status, notes: $notes) {\n    rga {\n      id\n      status\n      submittedBy\n      submittedOn\n      shippingSpeed\n      statusLog {\n        status\n        notes\n        updatedOn\n        updatedBy {\n          name\n          id\n          email\n        }\n      }\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useUpdateRgaStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRgaStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRgaStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRgaStatusMutation, { data, loading, error }] = useUpdateRgaStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateRgaStatusMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateRgaStatusDocument, options);
}
export var UpdateUserDocument = gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n    mutation UpdateUser($userInput: ExistingUserInput!) {\n  response: updateUser(userInput: $userInput) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "], ["\n    mutation UpdateUser($userInput: ExistingUserInput!) {\n  response: updateUser(userInput: $userInput) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n    errors {\n      message\n      path\n    }\n  }\n}\n    "])));
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUserDocument, options);
}
export var UserDocument = gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n    query User($userId: String!) {\n  user(id: $userId) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n    "], ["\n    query User($userId: String!) {\n  user(id: $userId) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n    "])));
/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(UserDocument, options);
}
export function useUserLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(UserDocument, options);
}
export var UsersDocument = gql(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n    query Users {\n  users {\n    id\n    firstName\n    lastName\n    email\n  }\n}\n    "], ["\n    query Users {\n  users {\n    id\n    firstName\n    lastName\n    email\n  }\n}\n    "])));
/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(UsersDocument, options);
}
export function useUsersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(UsersDocument, options);
}
export var FindDocumentWithSlugDocument = gql(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n    query FindDocumentWithSlug($slug: String!) {\n  response: documentBySlug(slug: $slug) {\n    success\n    errors {\n      message\n      path\n    }\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n  }\n}\n    "], ["\n    query FindDocumentWithSlug($slug: String!) {\n  response: documentBySlug(slug: $slug) {\n    success\n    errors {\n      message\n      path\n    }\n    document {\n      id\n      title\n      keywords\n      description\n      slug\n      fileKey\n      url\n    }\n  }\n}\n    "])));
/**
 * __useFindDocumentWithSlugQuery__
 *
 * To run a query within a React component, call `useFindDocumentWithSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDocumentWithSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDocumentWithSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFindDocumentWithSlugQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FindDocumentWithSlugDocument, options);
}
export function useFindDocumentWithSlugLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FindDocumentWithSlugDocument, options);
}
export var FindPageWithSlugDocument = gql(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n    query FindPageWithSlug($slug: String!) {\n  response: pageBySlug(slug: $slug) {\n    success\n    errors {\n      message\n      path\n    }\n    page {\n      title\n      id\n      slug\n      description\n      keywords\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          icon\n          name\n          description\n          position\n          type\n          target\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query FindPageWithSlug($slug: String!) {\n  response: pageBySlug(slug: $slug) {\n    success\n    errors {\n      message\n      path\n    }\n    page {\n      title\n      id\n      slug\n      description\n      keywords\n      sections {\n        id\n        name\n        position\n        items {\n          id\n          icon\n          name\n          description\n          position\n          type\n          target\n        }\n      }\n    }\n  }\n}\n    "])));
/**
 * __useFindPageWithSlugQuery__
 *
 * To run a query within a React component, call `useFindPageWithSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPageWithSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPageWithSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFindPageWithSlugQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FindPageWithSlugDocument, options);
}
export function useFindPageWithSlugLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FindPageWithSlugDocument, options);
}
export var RegisterProductDocument = gql(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n    mutation RegisterProduct($productRegistrationInput: NewProductRegistrationInput!) {\n  response: createProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    productRegistration {\n      id\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation RegisterProduct($productRegistrationInput: NewProductRegistrationInput!) {\n  response: createProductRegistration(\n    productRegistrationInput: $productRegistrationInput\n  ) {\n    productRegistration {\n      id\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useRegisterProductMutation__
 *
 * To run a mutation, you first call `useRegisterProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProductMutation, { data, loading, error }] = useRegisterProductMutation({
 *   variables: {
 *      productRegistrationInput: // value for 'productRegistrationInput'
 *   },
 * });
 */
export function useRegisterProductMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RegisterProductDocument, options);
}
export var SubmitRgaForReviewDocument = gql(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n    mutation SubmitRGAForReview($id: ID!, $notes: String) {\n  submitRGAForReview(id: $id, notes: $notes) {\n    rga {\n      id\n      shippingSpeed\n      submittedOn\n      submittedBy\n      status\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "], ["\n    mutation SubmitRGAForReview($id: ID!, $notes: String) {\n  submitRGAForReview(id: $id, notes: $notes) {\n    rga {\n      id\n      shippingSpeed\n      submittedOn\n      submittedBy\n      status\n    }\n    errors {\n      message\n      path\n    }\n    success\n  }\n}\n    "])));
/**
 * __useSubmitRgaForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitRgaForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRgaForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRgaForReviewMutation, { data, loading, error }] = useSubmitRgaForReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useSubmitRgaForReviewMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SubmitRgaForReviewDocument, options);
}
var result = {
    "possibleTypes": {}
};
export default result;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66;
